import { useQuery } from "@tanstack/react-query";
import { GET } from "../services/requests";
import { ENDPOINTS } from "../constants/endpoints";

export const useSerial = (id: string | undefined) => {
  const query = useQuery<any>(
    ["SERIAL", id],
    async () => {
      const data = await GET(`${ENDPOINTS.serial}/${id}`);
      return data;
    },
    {
      staleTime: 5 * (60 * 1000), 
      cacheTime: 7 * (60 * 1000),
      enabled: !!id,
    },
  );

  return {...query};
};
